<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <onaydialog ref="onaydialog"></onaydialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{Dizayn.FaturaAdi}} - {{ $t('Invoice-Design-Settings') }}  </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search3"  :label="this.$t('Search')" append-icon="search">
              </v-text-field>
              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" slot="activator" @click="dizaynkopyaladialog()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Copy-Design') }}  </span>
                  </span>
                  <v-icon right dark>file_copy</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update"> {{ $t('Copy-Design') }}  </span>
              </v-tooltip>


              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-tooltip bottom>
                    <v-list-tile slot="activator" :disabled="!sayfayetki.Update" @click="faturasatirekle()">
                      <v-list-tile-title>Satır Ekle</v-list-tile-title>
                    </v-list-tile>
                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                    <span v-if="sayfayetki.Update">Satır Ekle</span>
                  </v-tooltip>
                </v-list>
              </v-menu>


            </v-toolbar>
          </v-flex>




          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card flat color="grey lighten-5">
              <v-card-title>Yeni Dizayn Bilgileri</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">

                  <v-flex pa-1 xs12 sm12 md12>
                    <v-card flat="" class="white--text">
                      <v-card color="grey lighten-4" flat="">
                        <v-card-actions>
                          <v-layout v-if="islem==true" row wrap>
                            <v-flex xs12 sm12 md12>
                              <v-text-field hide-details="" :label="$t('Description')" v-model="DizaynValue.Aciklama">
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-text-field hide-details="" mask="####" :label="$t('E-Invoice')" v-model="DizaynValue.EFatura">
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-text-field hide-details="" :label="$t('Font')" v-model="DizaynValue.Font"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-text-field hide-details="" mask="####" :label="$t('Font-Size')"
                                v-model="DizaynValue.FontSize">
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-text-field hide-details="" label="Id" v-model="DizaynValue.Id">
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-text-field hide-details="" label="Ref" v-model="DizaynValue.Ref"></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-text-field hide-details="" :label="$t('Before')" v-model="DizaynValue.Once"></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm12 md6>
                              <v-text-field hide-details="" :label="$t('Reserved') + ' 1 (F,S,*)'"  v-model="DizaynValue.Reserved1">
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-text-field hide-details="" :label="$t('Reserved') + ' 2'"  v-model="DizaynValue.Reserved2">
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-text-field hide-details="" :label="$t('After')" v-model="DizaynValue.Sonra"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-text-field hide-details="" :label="$t('Style')" mask="A" v-model="DizaynValue.Style">
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md3>
                              <v-text-field hide-details="" mask="####" label="L" v-model="DizaynValue.L">
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md3>
                              <v-text-field hide-details="" mask="####" label="W" v-model="DizaynValue.W">
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md3>
                              <v-text-field hide-details="" mask="####" label="X" v-model="DizaynValue.X">
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md3>
                              <v-text-field hide-details="" mask="####" label="Y" v-model="DizaynValue.Y">
                              </v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout v-if="islem==false" row wrap>
                            <v-flex xs12 sm12 md12>
                              <v-form ref="formdizayn" v-model="valid" lazy-validation>
                                <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" :label="$t('New-Design-Name')"
                                  v-model="yenidizaynAdi"></v-text-field>
                              </v-form>


                            </v-flex>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>



                </v-layout>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>

                <v-tooltip bottom>
                  <v-btn v-if="islem==true && kayit==false" :disabled="!sayfayetki.Update" slot="activator"
                    color="blue darken-1" flat @click="kayitGuncelle()"> {{ $t('Update') }}
                  </v-btn>
                  <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <v-btn v-if="islem==true && kayit==true" :disabled="!sayfayetki.Save" slot="activator"
                    color="blue darken-1" flat @click="satirKaydet()"> Satır Kaydet
                  </v-btn>
                  <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Save">Satır Kaydet</span>
                </v-tooltip>


                <v-tooltip bottom>
                  <v-btn v-if="islem==false" :disabled="!sayfayetki.Update" slot="activator" color="blue darken-1" flat
                    @click="Kopyala()"> Kopyala
                  </v-btn>
                  <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Update">Kopyala</span>
                </v-tooltip>






              </v-card-actions>
            </v-card>
          </v-dialog>


          <v-container fluid="">
            <v-card color="grey lighten-5" flat>
              <v-form ref="formcariyegore" v-model="valid" lazy-validation>
              </v-form>
              <v-layout>

                <v-flex xs12 sm12 md12>
                  <v-card flat>

                    <v-data-table dense :headers="headers" :rows-per-page-items=[50,100]
                      :loading="progress" :items="items" :search="search3">
                      <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                      <template slot="items" slot-scope="props">
                        <tr item>
                          <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                          <td class="text-xs-left">{{ props.item.EFatura }}</td>
                          <td class="text-xs-left">{{ props.item.Font }}</td>
                          <td class="text-xs-left">{{ props.item.FontSize }}</td>
                          <td class="text-xs-left">{{ props.item.Id }}</td>
                          <td class="text-xs-left">{{ props.item.L }}</td>
                          <td class="text-xs-left">{{ props.item.Once }}</td>
                          <td class="text-xs-left">{{ props.item.Ref }}</td>
                          <td class="text-xs-left">{{ props.item.Reserved1 }}</td>
                          <td class="text-xs-left">{{ props.item.Reserved2 }}</td>
                          <td class="text-xs-left">{{ props.item.Sonra }}</td>
                          <td class="text-xs-left">{{ props.item.Style }}</td>
                          <td class="text-xs-left">{{ props.item.W }}</td>
                          <td class="text-xs-left">{{ props.item.X }}</td>
                          <td class="text-xs-left">{{ props.item.Y }}</td>
                          <td >




                             <v-tooltip bottom>
                              <v-btn icon small slot="activator" flat @click="Getir(props.item)">
                                <v-icon small color="green">edit</v-icon>
                              </v-btn>
                              <span>Düzenle</span>
                            </v-tooltip>

                            <v-tooltip bottom>
                              <v-btn icon small :disabled="!sayfayetki.Delete" slot="activator" color="red" flat
                                @click="satirsilSor(props.item.Ref)">
                                <v-icon small color="red">delete</v-icon>
                              </v-btn>
                              <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                              <span v-if="sayfayetki.Delete">Satır Sil</span>
                            </v-tooltip>




                          </td>
                        </tr>
                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="warning">
                           {{ $t('No-records-searched-for', { value: search3}) }}
                      </v-alert>
                    </v-data-table>


                  </v-card>
                  <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                    :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                    v-model="snackbar">
                    {{ text1 }}
                    <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
                  </v-snackbar>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>

        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import onaydialog from "@/components/app/customcomp/onaydialog.vue"


  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        kayit: false,
        dizaynitems: [],
        islem: true,
        yenidizaynAdi: null,
        DizaynValue: {
          Aciklama: null,
          EFatura: null,
          Font: null,
          FontSize: null,
          Id: null,
          L: null,
          Once: null,
          Ref: null,
          Reserved1: "",
          Reserved2: "",
          Sonra: "",
          Style: "",
          W: null,
          X: null,
          Y: null,
        },
        Dizayn: {
          FaturaAdi: 'IFATY',
          FaturaTip: 'B',
          FaturaID: null,
        },
        search: '',
        headers: [{
            text: 'Aciklama',
            value: 'Aciklama',
            sortable: false,
          width:'30px'
          },
          {
            text: 'EFaturai',
            value: 'EFatura',
            sortable: false
          },
          {
            text: 'Font',
            value: 'Font',
            sortable: false
          },
          {
            text: 'FontSize',
            value: 'FontSize',
            sortable: false
          },
          {
            text: 'Id',
            value: 'Id',
            sortable: false
          },
          {
            text: 'L',
            value: 'L',
            sortable: false

          }, {
            text: 'Once',
            value: 'Once',
            sortable: false
          },

          {
            text: 'Ref',
            value: 'Ref',
            sortable: false

          }, {

            text: 'Reserved1',
            value: 'Reserved1',
            sortable: false
          },
          {
            text: 'Reserved2',
            value: 'Reserved2',
            sortable: false
          },
          {
            text: 'Sonra',
            value: 'Sonra',
            sortable: false
          },
          {
            text: 'Style',
            value: 'Style',
            sortable: false
          },
          {
            text: 'W',
            value: 'W',
            sortable: false
          },
          {
            text: 'X',
            value: 'X',
            sortable: false
          },
          {
            text: 'Y',
            value: 'Y',
            sortable: false
          },
          {
            text: '',
            value: '',
            sortable: false

          }
        ],
        valid: true,
        text1: null,
        loading: false,
        progress: false,
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        search3: '',
        dialogfiltre: false,
        hesapkodu: [],
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        tooltip: false,
        el: null,
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp,
      yetkidialog,
      onaydialog
    },
    mounted() {



      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      if (this.sayfayetki.Status == true) {

        this.Dizayn.FaturaAdi = this.$route.query.faturaadi
        this.Dizayn.FaturaTip = this.$route.query.faturatip
        this.Dizayn.FaturaID = this.$route.query.id

        var params = {
          FaturaAdi: this.$route.query.faturaadi,
          FaturaTip: this.$route.query.faturatip
        }

        if (params.FaturaAdi != null && params.FaturaTip != null) {



          this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceDesignLoad', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            this.progress = false
            this.load1 = true

            this.items = response.body

            if (response.body != undefined) {

            } else {
              this.text1 = this.$t('No-Records-Found');
              this.snackbar = true;
              this.progress = false;
              this.load1 = true;
              this.items = [];
            }

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true

              this.load1 = true
              this.progress = false

            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.load1 = true
              this.progress = false
            }
          })

          var credentials = JSON.parse(window.localStorage.getItem('credentials'));
          var params3 = {
            SirketKodu: credentials.SirketKodu,
            FaturaTip: null,
            DovizliFatura: false,
            HatTipi: false,
            TumFiltre: false
          }
          this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params3, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.dizaynitems = response.body
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-InvoiceXsltTableList'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-InvoiceXsltTableList'
              this.snackbar = true
            }
          })
        } else {
          this.text1 = 'Dizayn ayarları bulunamadı. lütfen tekrar deneyiniz.'
          this.snackbar = true
        }



      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    watch: {
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },
    methods: {
       onKeyDown(evt){
      if (this.value.length >= this.max) {
        if (evt.keyCode >= 48 && evt.keyCode <= 90) {
          evt.preventDefault()
          return
        }
      }
    },
      satirsilSor(ref) {
        this.$refs.onaydialog.open("this.$t('Are-you-sure-you-want-to-delete-this-record')", 1).then(sonuc => {


          if (sonuc == true) {

            this.DizaynValue.Ref = null

            var params = {
              TabloInfo: {
                FaturaAdi: this.Dizayn.FaturaAdi,
                FaturaTip: this.Dizayn.FaturaTip,
              },
              SatirID: ref
            }

            this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceDesignLineDelete', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {

               this.text1 = this.$t(response.body.ResponseMessage)
              this.snackbar = true;

              if (response.body.Status == true) {

                this.dialogfiltre = false
                var params = {
                  FaturaAdi: this.Dizayn.FaturaAdi,
                  FaturaTip: this.Dizayn.FaturaTip
                }

                this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceDesignLoad', params, {
                  headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                  }
                }).then((response) => {

                  this.progress = false
                  this.load1 = true
                  this.items = response.body
                  this.islem = false
                }, (response) => {
                  if (response.status === 0) {
                    this.text1 = 'Service Unavailable-InvoiceDesignSave'
                    this.snackbar = true

                    this.load1 = true
                    this.progress = false

                  } else {
                    this.text1 = 'Service Unavailable-InvoiceDesignSave'
                    this.snackbar = true
                    this.load1 = true
                    this.progress = false
                  }
                })


              } else {
                this.progress = false;
                this.load1 = true;
                this.items = [];
              }

            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true

                this.load1 = true
                this.progress = false

              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
                this.load1 = true
                this.progress = false
              }
            })

          } 

        });

      },
      satirKaydet() {

        this.DizaynValue.Ref = null

        var params = {
          TabloInfo: {
            FaturaAdi: this.Dizayn.FaturaAdi,
            FaturaTip: this.Dizayn.FaturaTip,
          },
          SatirInfo: this.DizaynValue
        }

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceDesignLineSave', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true;

          if (response.body.Status == true) {

            this.dialogfiltre = false
            var params = {
              FaturaAdi: this.Dizayn.FaturaAdi,
              FaturaTip: this.Dizayn.FaturaTip
            }

            this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceDesignLoad', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {

              this.progress = false
              this.load1 = true
              this.items = response.body
              this.islem = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable-InvoiceDesignSave'
                this.snackbar = true

                this.load1 = true
                this.progress = false

              } else {
                this.text1 = 'Service Unavailable-InvoiceDesignSave'
                this.snackbar = true
                this.load1 = true
                this.progress = false
              }
            })


          } else {
            this.progress = false;
            this.load1 = true;
            this.items = [];
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

            this.load1 = true
            this.progress = false

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
          }
        })


      },
      faturasatirekle() {
        this.islem = true
        this.kayit = true
        this.DizaynValue.Aciklama = null;
        this.DizaynValue.EFatura = null;
        this.DizaynValue.Font = null;
        this.DizaynValue.FontSize = null;
        this.DizaynValue.Id = null;
        this.DizaynValue.L = null;
        this.DizaynValue.Once = null;
        this.DizaynValue.Ref = null;
        this.DizaynValue.Reserved1 = null;
        this.DizaynValue.Reserved2 = null;
        this.DizaynValue.Sonra = null;
        this.DizaynValue.Style = null;
        this.DizaynValue.W = null;
        this.DizaynValue.X = null;
        this.DizaynValue.Y = null;
        this.dialogfiltre = true
      },
      Kopyala() {
        if (this.$refs.formdizayn.validate()) {


          var index = this.dizaynitems.findIndex(p => p.FaturaTabloAdi == this.yenidizaynAdi)

          if (index == -1) {
            var params = {

              FaturaAdi: this.yenidizaynAdi,
              FaturaTip: this.Dizayn.FaturaTip,
              SaveUpdate: false,
              KopyaFaturaAdi: this.Dizayn.FaturaAdi,
              KopyaFaturaID: this.Dizayn.FaturaID,
              TableBilgi: this.items
            }

            this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceDesignSave', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {

               this.text1 = this.$t(response.body.ResponseMessage)
              this.snackbar = true;

              if (response.body.Status == true) {
                this.Dizayn.FaturaAdi = this.yenidizaynAdi
                this.dialogfiltre = false
                this.islem = false
                var params = {
                  FaturaAdi: this.yenidizaynAdi,
                  FaturaTip: this.Dizayn.FaturaTip
                }

                this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceDesignLoad', params, {
                  headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                  }
                }).then((response) => {

                  this.progress = false
                  this.load1 = true
                  this.items = response.body
                  this.islem = false
                }, (response) => {
                  if (response.status === 0) {
                    this.text1 = 'Service Unavailable-InvoiceDesignSave'
                    this.snackbar = true

                    this.load1 = true
                    this.progress = false

                  } else {
                    this.text1 = 'Service Unavailable-InvoiceDesignSave'
                    this.snackbar = true
                    this.load1 = true
                    this.progress = false
                  }
                })


              } else {
                this.progress = false;
                this.load1 = true;
                this.items = [];
              }

            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true

                this.load1 = true
                this.progress = false

              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
                this.load1 = true
                this.progress = false
              }
            })

          } else {
            this.text1 = this.$t('design-name-has-already-been-taken-enter-different-name')
            this.snackbar = true
          }




        }


      },
      dizaynkopyaladialog() {
        this.islem = false
        this.dialogfiltre = true
      },
      kayitGuncelle() {

        this.items.splice(this.kayitsirasi, 1);
        this.items.splice(this.kayitsirasi, 0, this.DizaynValue);

        var params = {
          FaturaAdi: this.Dizayn.FaturaAdi,
          FaturaTip: this.Dizayn.FaturaTip,
          SaveUpdate: true,
          KopyaFaturaAdi: null,
          TableBilgi: this.items
        }

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceDesignSave', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true;

          if (response.body.Status == true) {
            this.dialogfiltre = false
            var params = {
              FaturaAdi: this.Dizayn.FaturaAdi,
              FaturaTip: this.Dizayn.FaturaTip
            }

            this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceDesignLoad', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {

              this.progress = false
              this.load1 = true
              this.items = response.body
              this.islem = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable-InvoiceDesignSave'
                this.snackbar = true

                this.load1 = true
                this.progress = false

              } else {
                this.text1 = 'Service Unavailable-InvoiceDesignSave'
                this.snackbar = true
                this.load1 = true
                this.progress = false
              }
            })


          } else {
            this.progress = false;
            this.load1 = true;
            this.items = [];
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

            this.load1 = true
            this.progress = false

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
          }
        })

      },
      Getir(val) {
        this.islem = true
        this.kayit = false
        this.kayitsirasi = this.items.indexOf(val)
        this.DizaynValue.Aciklama = val.Aciklama
        this.DizaynValue.EFatura = val.EFatura
        this.DizaynValue.Font = val.Font
        this.DizaynValue.FontSize = val.FontSize
        this.DizaynValue.Id = val.Id
        this.DizaynValue.L = val.L
        this.DizaynValue.Once = val.Once
        this.DizaynValue.Ref = val.Ref
        this.DizaynValue.Reserved1 = val.Reserved1
        this.DizaynValue.Reserved2 = val.Reserved2
        this.DizaynValue.Sonra = val.Sonra
        this.DizaynValue.Style = val.Style
        this.DizaynValue.W = val.W
        this.DizaynValue.X = val.X
        this.DizaynValue.Y = val.Y
        this.dialogfiltre = true
      },

      getList: getList,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal

    }
  }


  function filtrekayit() {
    this.filtrevarmi = true
    this.getList();
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.dialogfiltre = false
    this.yenidizaynAdi = null
    this.islem = false
  }

  function getList() {}

  function beforeMount() {}
</script>

<style scoped>

table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
  padding: 0 10px
}
</style>